import AccountPayableListModal from '@/components/_common/AccountPayableListModal';
import AccountReceivableListModal from '@/components/_common/AccountReceivableListModal';
import SkeletonCustom from '@/components/_common/SkeletonCustom';
import StatisticDashboard, {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import { InstallmentSituation } from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { AccountReceivableSituation } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { useDashboardQuick } from '@/core/domain/workorder/Dashboard/Dashboard.hooks';
import { DashboardType } from '@/core/domain/workorder/Dashboard/Dashboard.types';
import { useDisclosure, useWindowSize } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import formatterPrice from '@/utils/number/formatterPrice';
import { Col, Row } from 'antd';
import moment from 'moment';
import React from 'react';

const StatisticFinancialView: React.FC = () => {
  const { isMobile } = useWindowSize();

  const [viewAccountReceivablesOpen, viewAccountReceivablesActions] =
    useDisclosure();
  const [viewAccountPayablesOpen, viewAccountPayablesActions] = useDisclosure();
  const [viewPayableExpiredlValueOpen, viewPayableExpiredlValueActions] =
    useDisclosure();
  const [viewReceivableExpiredlValueOpen, viewReceivableExpiredlValueActions] =
    useDisclosure();

  const { data, isLoading } = useDashboardQuick({
    dashboardType: DashboardType.financial,
  });

  return (
    <SkeletonCustom loading={isLoading} skeletonType="INPUT" skeletonCount={4}>
      <Row gutter={[24, 24]} justify="space-between">
        <Col>
          <StatisticDashboard
            tooltipTitle="Valor total dos lançamentos do contas a receber que tem data de vencimento até o dia anterior."
            statisticTitle={
              isMobile
                ? 'Parcelas a Receber Venc.'
                : 'Parcelas a Receber Vencidas'
            }
            statisticValue={formatterPrice(data?.receivableExpiredValue || 0)}
            color={StatisticDashboardTypeColor.info}
            onClick={viewReceivableExpiredlValueActions.open}
            dashboardModule={StatisticDashboardModule.accountReceivable}
          />
        </Col>

        <Col>
          <StatisticDashboard
            tooltipTitle="Valor total dos lançamentos do contas a receber que tem data de vencimento dentro do mês atual."
            statisticTitle={`A Receber | ${moment()
              .format('MMM')
              .toUpperCase()}`}
            statisticValue={formatterPrice(data?.receivableMonthValue || 0)}
            color={StatisticDashboardTypeColor.income}
            onClick={viewAccountReceivablesActions.open}
            dashboardModule={StatisticDashboardModule.accountReceivable}
          />
        </Col>

        <Col>
          <StatisticDashboard
            tooltipTitle="Valor total dos lançamentos do contas a pagar que tem data de vencimento dentro do mês atual."
            statisticTitle={`A Pagar | ${moment().format('MMM').toUpperCase()}`}
            statisticValue={formatterPrice(data?.payableMonthValue || 0)}
            color={StatisticDashboardTypeColor.expense}
            onClick={viewAccountPayablesActions.open}
            dashboardModule={StatisticDashboardModule.accountPayable}
          />
        </Col>

        <Col>
          <StatisticDashboard
            tooltipTitle="Valor total dos lançamentos do contas a pagar que tem data de vencimento até o dia anterior."
            statisticTitle={
              isMobile ? 'Parcelas a Pagar Venc.' : 'Parcelas a Pagar Vencidas'
            }
            statisticValue={formatterPrice(data?.payableExpiredValue || 0)}
            color={StatisticDashboardTypeColor.expense}
            onClick={viewPayableExpiredlValueActions.open}
            dashboardModule={StatisticDashboardModule.accountPayable}
          />
        </Col>
      </Row>

      <AccountReceivableListModal
        open={viewAccountReceivablesOpen}
        onCancel={viewAccountReceivablesActions.close}
        queryFilter={{
          situation: AccountReceivableSituation.open,
          initialDueDate: moment().startOf('month').format(DateTimeFormat),
          finalDueDate: moment().endOf('month').format(DateTimeFormat),
        }}
      />

      <AccountReceivableListModal
        open={viewReceivableExpiredlValueOpen}
        onCancel={viewReceivableExpiredlValueActions.close}
        queryFilter={{
          situation: AccountReceivableSituation.open,
          finalDueDate: moment().subtract(1, 'day').format(DateTimeFormat),
        }}
      />

      <AccountPayableListModal
        open={viewAccountPayablesOpen}
        onCancel={viewAccountPayablesActions.close}
        queryFilter={{
          situation: InstallmentSituation.open,
          initialDueDate: moment().startOf('month').format(DateTimeFormat),
          finalDueDate: moment().endOf('month').format(DateTimeFormat),
        }}
      />

      <AccountPayableListModal
        open={viewPayableExpiredlValueOpen}
        onCancel={viewPayableExpiredlValueActions.close}
        queryFilter={{
          situation: InstallmentSituation.open,
          finalDueDate: moment().subtract(1, 'day').format(DateTimeFormat),
        }}
      />
    </SkeletonCustom>
  );
};

export default StatisticFinancialView;
